import { useState, useEffect } from 'react'
import { useFirefly } from '../../../../../resources/useAnalytics'

export const useSavedSearchModal = () => {
  // const makeToast = useToaster()
  const { handleTrackEvent } = useFirefly()

  const [showEditModal, setShowEditModal] = useState(false)
  const [editSavedSearch, setEditSavedSearch] = useState()
  const [inputValue, setInputValue] = useState()
  const [isChecked, setIsChecked] = useState(false)
  const [modalName, setModalName] = useState('edit')
  // Get saved searches
  useEffect(() => {
    setInputValue(inputValue)
  }, [inputValue])
  const handelModal = (value, type) => {
    setModalName(type)
    setShowEditModal(!showEditModal)
    setEditSavedSearch(value)
    handleTrackEvent(
      value?.favorite ? 'Favorite Saved Search' : 'Saved Search',
      type,
    )
  }

  return {
    showEditModal,
    editSavedSearch,
    inputValue,
    setInputValue,
    isChecked,
    setIsChecked,
    modalName,
    handelModal,
  }
}
